import React, { createContext, useContext } from 'react'
import { ConnectionStatus, NetworkQualityInfo } from '../types'

interface NetworkQualityContextValue {
  networkQuality: NetworkQualityInfo
  connectionStatus: ConnectionStatus
  networkMessage: string
}

const NetworkQualityContext = createContext<NetworkQualityContextValue | null>(
  null
)

interface Props extends NetworkQualityContextValue {
  children: React.ReactNode
}

export function NetworkQualityProvider({
  children,
  networkQuality,
  connectionStatus,
  networkMessage,
}: Props) {
  return (
    <NetworkQualityContext.Provider
      value={{ networkQuality, connectionStatus, networkMessage }}
    >
      {children}
    </NetworkQualityContext.Provider>
  )
}

export function useNetworkQuality() {
  const context = useContext(NetworkQualityContext)
  if (!context) {
    throw new Error(
      'useNetworkQuality precisa ser usado com NetworkQualityProvider'
    )
  }
  return context
}
